/**
 * Follows a notification's link on the creative page (Aziz 2026-09-29): opens the section
 * the link names (#chat, #work, #assets, #shoot), scrolls to it and marks it for a moment.
 * A link to a file (?asset=) opens the Assets section; AssetsPanel then opens the file.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SECTION_FOLD } from '@/lib/deep-link';

export default function FollowLink() {
  const { hash, search, key } = useLocation();
  useEffect(() => {
    const section = (hash || '').replace('#', '') || (new URLSearchParams(search).get('asset') ? 'assets' : '');
    if (!section || !SECTION_FOLD[section]) return;
    window.dispatchEvent(new CustomEvent('kaf:open-section', { detail: SECTION_FOLD[section] }));
    const t = window.setTimeout(() => {
      const el = document.getElementById(section);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      el.classList.add('ring-2', 'ring-accent-400/70');
      window.setTimeout(() => el.classList.remove('ring-2', 'ring-accent-400/70'), 2200);
    }, 350);
    return () => window.clearTimeout(t);
  }, [hash, search, key]);
  return null;
}
